interface SubtractIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}
export function SubtractIcon({ color = 'currentColor', ...svgProps }: SubtractIconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <line
        x1="12.5"
        y1="9"
        x2="4.5"
        y2="9"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
